<template>
  <nav class="navbar navbar-expand-lg navbar-sennder fixed-top" id="navbar">
    <router-link to="/" class="navbar-brand">
      <img src="../../assets/img/logo_original.svg" width="130" />
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav mr-auto">
        <router-link to="/" tag="li" class="nav-item" exact-active-class="active">
          <a class="nav-link" v-translate>TRANSFERS</a>
        </router-link>
        <router-link
          to="/trackers"
          tag="li"
          class="nav-item"
          exact-active-class="active"
          v-if="user.inStaffGroup"
        >
          <a class="nav-link" v-translate>TRACKERS</a>
        </router-link>
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a
            href="#"
            data-target="#"
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
          >
            {{ user.username }}
            <b class="caret"></b>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a href="#" class="dropdown-item" @click="logout">
              <i class="material-icons">exit_to_app</i>
              <translate>Log out</translate>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import router from '../../router'
import User from '../../models/user'

export default {
  props: ['user'],
  methods: {
    logout(e) {
      if (e) {
        e.preventDefault()
      }
      User.logout()
      router.push({ path: '/login' })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>
